import { Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import axios from "axios";
import { useEffect, useState } from "react";
import SinglePage from "./pages/SinglePage";

function App() {
  const [menuItems, setMenuItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getMenuItems = async () => {
      try {
        const request = await axios.get(
          "https://restoran-menu-default-rtdb.firebaseio.com/results.json"
        );
        const data = request.data;
        const loadedMenu = [];

        for (const item in data) {
          loadedMenu.push({
            id: item,
            name: data[item].name,
            items: data[item].items,
            image: data[item].image,
            route: data[item].route,
          });
        }

        setMenuItems(loadedMenu);
        setIsLoading(false);
      } catch (error) {
        throw new Error("Bir hata oluştu!");
      }
    };

    getMenuItems();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Homepage menuItems={menuItems} />} />
      {menuItems.map((item) => (
        <Route
          key={item.id}
          path={`/${item.route}`}
          element={<SinglePage category={item} />}
        />
      ))}
    </Routes>
  );
}

export default App;
